import { call, put, select } from 'redux-saga/effects';
import { getEnvVar } from 'helpers';
import {
  queryingSurveyAi,
  querySurveyAiSucceeded,
  querySurveyAiFailed
} from './actions';
import { querySurveyAiGenerator } from 'features/surveyAi/services/surveyAiApi';

export function* querySurveyAiRequest(action) {
  const payload = action.payload || {};
  const {
    text,
    messageHistory,
    query,
    currentSurveyJSON,
    selectedElement,
    signal,
    resolve,
    reject
  } = payload;

  const tenantId = yield select(store => store.user.selectedTenant?.tenantId);
  const contextId = yield select(
    store => store.user.selectedBusinessContext?.businessContextId
  );
  const xToken = yield select(store => store.user.xToken);
  const surveyApiRoot = getEnvVar('REACT_APP_SURVEY_API_PATH') || '/';

  try {
    yield put(queryingSurveyAi());
    const response = yield call(querySurveyAiGenerator, {
      surveyApiRoot,
      tenantId,
      contextId,
      text,
      messageHistory,
      query,
      currentSurveyJSON,
      selectedElement,
      xToken,
      signal
    });

    yield put(querySurveyAiSucceeded(response));
    if (typeof resolve === 'function') {
      resolve(response);
    }
  } catch (error) {
    yield put(querySurveyAiFailed(error));
    if (typeof reject === 'function') {
      reject(error);
    }
  }
}
